export default "__VITE_ASSET__43f002e1__"